import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { AppRoute } from '@/common/app/routes';
import { H1 } from '@/components/Typography/Typography';
import { clearServerError } from '@/redux/reducers/userReducer';
import { type RootState } from '@/redux/store';

import css from './style.module.scss';

import errorIconPng from '/img/icons/error_page/errorIcon.png';
import errorIconWebp from '/img/icons/error_page/errorIcon.webp';

const ErrorPage: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const errorStatus = useSelector(
    (state: RootState) => state.user.serverErrorStatus,
  );
  const { t } = useTranslation();

  return (
    <div className={css.errorPage}>
      <div>
        <picture>
          <source srcSet={errorIconWebp} type="image/webp" />
          <img src={errorIconPng} alt="character" />
        </picture>
      </div>
      <div>
        <H1>{t('Oops!')}</H1>
        <p>{t('We re currently down for maintenance.')}</p>
      </div>
      <div>
        <button
          className="btn"
          type="button"
          onClick={() => {
            dispatch(clearServerError());
            navigate(AppRoute.MAIN);
          }}
        >
          {t('Back to Office')}
        </button>
      </div>
      <div className="absolute bottom-[5%]">
        <span>{errorStatus ? errorStatus : '500'}</span>
      </div>
    </div>
  );
};

export default ErrorPage;
